import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { CalendlyPage } from "./CalendlyPage";

export function Calendly() {
  return (
    <div className="d-flex flex-column flex-root" style={{backgroundColor: '#0a0a0a'}}> 
      <Switch>
        <ContentRoute path="/calendly" component={CalendlyPage} />
        <Redirect to="/calendly" />
      </Switch>
    </div>
  );
}